export const arrayObjectHasValue = (array, key, value) => array.some(i => i[key] === value)